import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { useGlobal } from '~/hooks/useGlobal';

import MobileHeaderLayout from '../../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../../Main/MobileHeader/MobileHeaderTitle';

import styles from './CheckoutSkeletonCD.module.scss';

export const SkeletonCD = ({ className }: { className?: string }) => {
  return <div className={classes([styles.skeleton, className])} />;
};

const CheckoutSkeleton = () => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  return (
    <div
      className={classes([
        'checkout desktop',
        styles.page,
        company.newDesignSystemEnabled && styles.newVersion,
      ])}
    >
      <MobileHeaderLayout
        content={<MobileHeaderTitle text={t('checkout:title')} />}
        className={styles.mobileHeader}
      />
      <div className={classes(['content-layout', styles.layout])}>
        <div className={classes([styles.root, styles.skeleton])}>
          <div className={styles.content}>
            <div className={styles.mapContainer}>
              <div className={styles.selectAddress}>
                {!isMobile && <SkeletonCD className={styles.icon} />}
              </div>
            </div>
            <div className={styles.comment}>
              {!isMobile && <SkeletonCD className={styles.icon} />}
            </div>
            <div className={styles.expressDelivery}>
              {!isMobile && <SkeletonCD className={styles.icon} />}
            </div>
            <div className={styles.deliveryTime}>
              {!isMobile && (
                <div>
                  <SkeletonCD className={styles.icon} />
                </div>
              )}
              <div className={styles.cardList}>
                {new Array(isMobile ? 4 : 6).fill(0).map((_, index) => (
                  <SkeletonCD className={styles.card} key={index} />
                ))}
              </div>
            </div>
          </div>

          <div className={styles.summary}>
            <div className={styles.paymentMethods} />
            <div className={styles.promocode} />
            {!isMobile ? (
              <div className={styles.paymentInfo}>
                <SkeletonCD className={styles.subtotal} />
                <SkeletonCD className={styles.deliveryFee} />
                <div className={styles.constInfo}>
                  <SkeletonCD className={styles.promocodeDiscount} />
                  <SkeletonCD className={styles.vat} />
                  <div className={styles.total}>
                    <SkeletonCD className={styles.totalTitle} />
                    <SkeletonCD className={styles.totalValue} />
                  </div>
                  <SkeletonCD className={styles.confirmButton} />
                </div>
              </div>
            ) : (
              <div className={styles.paymentInfoMobile}>
                <SkeletonCD className={styles.subtotal} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(CheckoutSkeleton);
